<template>

  <div class="Check">
    <Icon name="check" />
  </div>

</template>

<script>
  import Icon from '@components/Icon'

  export default {
    components: { Icon }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Check.scss";
</style>
